import { Platform } from 'react-native';

import { routes } from '@fhs-legacy/frontend/src/utils/routing';

export function getOffersAndRewardsHref(enableRewardsTiers: boolean, noStoreSelected: boolean) {
  // TODO: Remove the flag parameter and legacy Offers fallback when the
  // enable-rewards-tiers flag is fully retired from the menu experience.
  // Keep the combined native experience inside the Rewards tab; web and legacy Offers
  // continue using the standalone route.
  const destination =
    enableRewardsTiers && Platform.OS !== 'web' ? routes.rewardsTab : routes.offersV2;

  // Check before switching tabs: the Rewards guard replaces the whole tabs entry with
  // the locator, losing the active Menu tab. Open the locator above Menu instead.
  return noStoreSelected
    ? `/store-locator/service-mode?back=${encodeURIComponent(destination)}`
    : destination;
}
